import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of } from 'rxjs';
import { FeedItemsResponseDto } from 'src/app/shared/dtos/feed-items.dto';
import { transformAndValidatePipe } from 'src/app/shared/utils/operators';
import { datadogLogs } from '@datadog/browser-logs';

@Injectable({
  providedIn: 'root'
})
export class FeedItemsService {
  http = inject(HttpClient);

  getFeedItems(): Observable<FeedItemsResponseDto | null> {
    return this.http.get<FeedItemsResponseDto>(`/api/feed-items`).pipe(
      transformAndValidatePipe(FeedItemsResponseDto),
      catchError((err: Error) => {
        datadogLogs.logger.error('Error fetching content list:', {}, err);

        return of(null);
      })
    );
  }
}
